// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import { Transition } from '@headlessui/react';
import { FC } from 'react';
import { ReactComponent as Logo } from '../../assets/logo/andCOCO_logo.svg';
import { Link } from '../Link.client';
import { Responsive } from '../Responsive.client';
import { DesktopHeaderDetail } from './DesktopHeaderDetail.client';
import { DesktopNavigation } from './DesktopNavigation.client';
import { MobileNavigation } from './MobileNavigation.client';

interface Props {
  show: boolean;
  isLogin: boolean;
  onClickSearch: () => void;
}

export const FixedHeader: FC<Props> = (props) => (
  <div className="fixed top-0 z-40 w-screen">
    <Transition
      show={props.show}
      enter="transform transition ease-in-out duration-700"
      enterFrom="-translate-y-full"
      enterTo="translate-y-0"
      leave="transform transition ease-in-out duration-75"
      leaveFrom="translate-y-0"
      leaveTo="-translate-y-full"
    >
      <Responsive desktop={DesktopFixedHeader} mobile={MobileFixedHeader} props={props} />
    </Transition>
  </div>
);

const DesktopFixedHeader: FC<Props> = ({ onClickSearch }) => (
  <div className="border-t-2 border-brand bg-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
    <div className="wrapper flex justify-between py-1">
      <Link route="home">
        <Logo width={150} />
      </Link>
      <DesktopHeaderDetail onClickSearch={onClickSearch} />
    </div>
    <DesktopNavigation />
  </div>
);

const MobileFixedHeader: FC<Props> = ({ isLogin }) => (
  <div className="border-t-2 border-brand bg-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
    <MobileNavigation isLogin={isLogin} />
  </div>
);
